import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getNutrientDv = async (options) => {
  // Check if options is a string (for backward compatibility)
  if (typeof options === 'string') {
    options = { shareToken: options };
  }

  const { shareToken, workflowId } = options;

  // Validate that at least one parameter is provided
  if (!shareToken && !workflowId) {
    console.error('Either shareToken or workflowId must be provided');
  }

  // Build the URL based on which parameter is provided
  let apiURL = API_HOST + '/diets/nutrient_dv_list';
  if (shareToken) {
    apiURL += '?share_token=' + shareToken;
  } else {
    apiURL += '?workflow_id=' + workflowId;
  }

  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
